var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedIconMylocationError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8A95AE",
    opacity: 0.6,
    d: "M12.695 11.002h-.473l.169-2.688a6.356 6.356 0 0 1 .304 2.688zm-.061.454A6.365 6.365 0 0 1 0 10.362a6.364 6.364 0 0 1 8.812-5.875v1.41A5.057 5.057 0 0 0 7 5.312v2.294H5.727V5.31a5.093 5.093 0 0 0-4.415 4.415h2.294v1.272H1.312a5.093 5.093 0 0 0 4.415 4.416V13.12H7v2.294a5.095 5.095 0 0 0 4.337-3.958h1.296z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A849D",
    d: "M13.267.547a4 4 0 0 0-4 4v3.547a.64.64 0 0 1-.162.424 78.133 78.133 0 0 0-1.254 1.454.626.626 0 0 0 .483 1.03h7.388a4 4 0 0 0 4-4V4.547a4 4 0 0 0-4-4h-2.455z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.434 9.057c-.373 0-.675-.312-.675-.712 0-.395.302-.707.675-.707.37 0 .671.312.671.707 0 .4-.302.712-.671.712zM13.703 3.576a.735.735 0 1 1 1.464-.007l-.228 2.759a.494.494 0 0 1-.984.004l-.252-2.756z"
  })));
}
export default SvgFeedIconMylocationError;